import { Injectable } from "@angular/core";
import { environment } from "src/environments/environment";
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Observable } from "rxjs";

import { Workshop } from "src/models/workshop";
import { createWorkshop } from '../../models/createWorkshopInterface';
import { HelperService } from "../helperService";




@Injectable({
    providedIn: 'root'
})
export class APIWorkshopService {
    ApiURL: string = "";
    constructor(private http: HttpClient,public helperService: HelperService) {
    this.ApiURL = environment.WorkShopURL + 'Workshop/';
    }

    public get(id: string): Observable<any>{ 
        const headers = new HttpHeaders().set('Authorization', `Bearer ${this.helperService.TokenBooking}`);
        const requestOptions = {
            headers: headers,
          };
        if (id !== null && id !== undefined) { 

            return this.http.get(this.ApiURL + encodeURIComponent(id),requestOptions);
       } else {
           return this.http.get(this.ApiURL ,requestOptions);
        }}

    public getManagement(id: any, idOp: any, brand?: any): Observable<Workshop[]> {
        const headers = new HttpHeaders().set('Authorization', `Bearer ${this.helperService.TokenBooking}`);
        const requestOptions = {
            headers: headers,
          };
        const brandParam = brand !== undefined ? `/${encodeURIComponent(brand)}` : '';
        const url = `${this.ApiURL}Workshop/${encodeURIComponent(id)}/${encodeURIComponent(idOp)}${brandParam}`;
        
        return this.http.get<Workshop[]>(url,requestOptions);
        }
        

    public post(workshop:createWorkshop): Observable<any>{
        const headers = new HttpHeaders().set('Authorization', `Bearer ${this.helperService.TokenBooking}`);
        const requestOptions = {
            headers: headers,
          };
        return this.http.post<any>(this.ApiURL+"CreateWorkshopDataJson/", workshop,requestOptions) }

    public put(workshop:Workshop): Observable<{}>{ 
        const headers = new HttpHeaders().set('Authorization', `Bearer ${this.helperService.TokenBooking}`);
        const requestOptions = {
            headers: headers,
          };
        return this.http.put(this.ApiURL,workshop,requestOptions)
    }
    public delete(id: string):  Observable<{}>{ 
        const headers = new HttpHeaders().set('Authorization', `Bearer ${this.helperService.TokenBooking}`);
        const requestOptions = {
            headers: headers,
          };
        let apiURL = `${this.ApiURL}${id}`; 
        return this.http.delete(apiURL,requestOptions)
    }
   
    public allWorkshopEditCreateData():Observable<any>{
        const headers = new HttpHeaders().set('Authorization', `Bearer ${this.helperService.TokenBooking}`);
        const requestOptions = {
            headers: headers,
          };
        return this.http.get(this.ApiURL+"getworkshopdata",requestOptions)
    }

    // get the countryBrandRetailId based on the brand and workshopId
    public getCountryBrandRetailIdByBrandAndWorkshopId(brandId:number, WorkshopId:number){
        const headers = new HttpHeaders().set('Authorization', `Bearer ${this.helperService.TokenBooking}`);
        const requestOptions = {
            headers: headers,
          };
        return this.http.get(`${environment.WorkshopCountryUrl}CountryBrandRetailWorkshop/GetByBrandIdAndWorkshopId/${brandId}/${WorkshopId}`,requestOptions)
    }
    
}